const moment = require('moment')
import db from '../../store/local.js'
import {K_LOGINED_USER} from '../constant.js'
let localCacheUser = null
export default {
  dtFormat (dt, pat) {
    if (!dt) {
      return ''
    }
    let pattern = pat || 'YYYY-MM-DD'
    return moment(dt).format(pattern)
  },
  parse2Long (dt, pat) {
    if (!dt) {
      return 0
    }
    return moment(dt, pat).format('X') * 1000
  },
  toDate (dt, pat) {
    return new Date(moment(dt, pat))
  },
  usr () {
    if (!localCacheUser) {
      console.log('no cache user')
      localCacheUser = db.get(K_LOGINED_USER)
    }
    return localCacheUser
  },
  delUserCache () {
    localCacheUser = null
  },
  permissions () {
    let user = this.usr()
    if (user) {
      return user.account.permissions
    }
    return []
  },
  auth (perm) {
    if (!perm) {
      return false
    }
    let allPermissions = this.usr().account.permissions
    if (typeof perm === 'object' && perm.constructor === Array) {
      for (let i in perm) {
        if (allPermissions.indexOf(perm[i]) > -1) {
          return true
        }
      }
    } else {
      return allPermissions.indexOf(perm) > -1
    }
  },
  isSuper () {
    if (this.usr()) {
      return this.usr().account.is_superuser === 1
    }
    return false
  },
  uid () {
    if (this.usr()) {
      return this.usr().account.id
    }
    return ''
  },
  session () {
    if (this.usr()) {
      return this.usr().session
    }
    return ''
  },
  strify (obj) {
    let cache = []
    return JSON.stringify(obj, function (key, value) {
      console.log(key)
      if (typeof value === 'object' && value !== null) {
        if (cache.indexOf(value) !== -1) {
          return '[circluar object]'
        }
        // Store value in our collection
        cache.push(value)
        if (value.$data && value.$root) {
          return '[Vue Component]'
        }
      }
      return value
    })
  },
  resetPager () {
    this.$store.dispatch('setPageIndex', 1)
  },
  showLopeLoading () {
    window.$('.lp-overlay').show()
  },
  hideLopeLoading () {
    window.$('.lp-overlay').hide()
  }
}



// WEBPACK FOOTER //
// ./src/lib/methods/common.js